import {
  AccountSearchResultModel,
  BblDocumentSearchResultModel,
  BoardDocumentSearchResultModel,
  BoardMeetingCaseResultModel,
  InvoiceSearchResultModel,
  MenuSearchResultModel,
  ProsjektarkivDocumentSearchResultModel,
} from '../model'
import React from 'react'

type IGlobalSearchContext = {
  error: unknown
  loading: boolean
  menuHits?: MenuSearchResultModel
  boardMeetingHits?: BoardMeetingCaseResultModel
  invoiceHits?: InvoiceSearchResultModel
  accountHits?: AccountSearchResultModel
  bblDocumentsHits?: BblDocumentSearchResultModel
  boardDocumentHits?: BoardDocumentSearchResultModel
  prosjektarkivDocumentHits?: ProsjektarkivDocumentSearchResultModel
}

export const GlobalSearchContext = React.createContext<IGlobalSearchContext>(
  {} as IGlobalSearchContext
)

export const useGlobalSearchContext = () => {
  const context = React.useContext(GlobalSearchContext)

  if (!context) {
    throw new Error(
      'useGlobalSearchContext must be used within a GlobalSearchProvider'
    )
  }

  return context
}
